import { useCallback, useState } from 'react';
import APIAgent from '../../../agents/apiAgent';

export function useOfferHistory() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(async (offerId) => {
    if (!offerId) {
      setHistory([]);
      return [];
    }
    setLoading(true);
    try {
      const data = await APIAgent.request(`/api/offers/${offerId}/history`);
      const list = Array.isArray(data) ? data : (data?.history || []);
      setHistory(list);
      setError(null);
      return list;
    } catch (err) {
      setError('Error fetching history: ' + err.message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return { history, loading, error, fetchHistory };
}
